/**
 * Put a chosen person, or a typed name with nobody behind it, onto a form.
 *
 * BOTH halves are stored on purpose. The id is the only thing a queue or a
 * register can group on -- typed names are why "Dr Sen" and "Dr R. Sen" count
 * as two surgeons today. The name is stored beside it, denormalised, for the
 * same reason ot_case_team denormalises member_name: a closed case has to keep
 * reading correctly after the doctor leaves.
 *
 * Dropping the id on free text is the half that matters. A stale id left
 * behind would make the case claim someone the typist did not pick, and that
 * is a worse record than a name with no id.
 */
export function applyStaffSelection(form, idKey, nameKey, picked) {
  if (picked && typeof picked === "object") {
    return {
      ...form,
      [idKey]: picked.member_id || "",
      [nameKey]: picked.member_name || "",
    };
  }
  return {
    ...form,
    [idKey]: "",
    [nameKey]: typeof picked === "string" ? picked : "",
  };
}
